// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Adminlogin from "./component/Admin/Adminlogin";


// import Login from "./component/General/Login";
// import Dashboard from "./component/General/Dashboard";

// function App() {
//    const data = localStorage.getItem("admin");
//         const admin = JSON.parse(data);
//   return (
//     <BrowserRouter>
//       <Routes>
        
//         <Route path="/admin-login" element={<Adminlogin />} />
//         <Route path="/" element={<Login/>} />
//                 <Route path="/admin-dashboard" element={<Dashboard/>} />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;

// import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import Adminlogin from "./component/Admin/Adminlogin";
// import Login from "./component/General/Login";
// import Dashboard from "./component/General/Dashboard";
// import Sidebar from "./component/General/Sidebar";
// import Manageprojects from "./component/Admin/Manageprojects";
// import Manageleads from "./component/Admin/Manageleads";
// import Managesubpanel from "./component/Admin/Managesubpanel";
// import Projectcompletion from "./component/Admin/Projectcompletion";
// import Projectalloted from "./component/siteMaster/Projectalloted";

// function App() {
//   const data = localStorage.getItem("admin");
//   const admin = JSON.parse(data);

//   return (
//     <BrowserRouter>
//       <Routes>

//         {/* PUBLIC ROUTES */}
//         {!admin && (
//           <>
//             <Route path="/" element={<Login />} />
//             <Route path="/admin-login" element={<Adminlogin />} />
           
//           </>
//         )}

//         {/* PROTECTED ROUTES */}
//         {admin != null &&  (
//           <>
//             <Route path="/admin" element={<Sidebar admin={admin} />}>
              
            


//               <Route path="/admin/dashboard" element={<Dashboard />} />
//                  <Route path="/admin/manage-projects" element={<Manageprojects />} />
//                  <Route path="/admin/project-completion" element={<Projectcompletion />} />
//                   <Route path="/admin/manage-staff" element={<Managesubpanel />} />
//               {admin.role == 'admin' && <Route path="/admin/project-alloted" element={<Projectalloted />} />
//             </Route>

          
//           </>
//         )}

//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;

// import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import Adminlogin from "./component/Admin/Adminlogin";
// import Login from "./component/General/Login";
// import Dashboard from "./component/General/Dashboard";
// import Sidebar from "./component/General/Sidebar";
// import Manageprojects from "./component/Admin/Manageprojects";
// import Managesubpanel from "./component/Admin/Managesubpanel";
// import Projectcompletion from "./component/Admin/Projectcompletion";
// import Projectalloted from "./component/siteMaster/projectalloted";


// function App() {
//   const data = localStorage.getItem("admin");
//   const admin = data ? JSON.parse(data) : null;

//   return (
//     <BrowserRouter>
//       <Routes>

//         <Route
//           path="/"
//           element={
//             admin ? <Navigate to="/admin/dashboard" /> : <Login />
//           }
//         />


//         <Route
//           path="/admin-login"
//           element={
//             admin ? <Navigate to="/admin/dashboard" /> : <Adminlogin />
//           }
//         />


//         <Route
//           path="/admin"
//           element={
//             admin ? <Sidebar admin={admin} /> : <Navigate to="/admin-login" />
//           }
//         >
//           <Route path="dashboard" element={<Dashboard />} />
//           <Route path="manage-projects" element={<Manageprojects />} />
//           <Route path="project-completion" element={<Projectcompletion />} />
//           <Route path="manage-staff" element={<Managesubpanel />} />
//           <Route path="project-alloted" element={< Projectalloted/>} />
          

//         </Route>

//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;


import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Adminlogin from "./component/Admin/Adminlogin";
import Login from "./component/General/Login";
import Dashboard from "./component/General/Dashboard";
import Sidebar from "./component/General/Sidebar";
import Manageprojects from "./component/Admin/Manageprojects";
import Managesubpanel from "./component/Admin/Managesubpanel";
import Projectcompletion from "./component/Admin/Projectcompletion";
import Projectalloted from "./component/siteMaster/Projectalloted";
import Pnf from "./component/General/pnf";
import Clientonboarding from "./component/siteMaster/Clientonboarding";
import Invoiceform from "./component/Admin/Invoiceform";

function App() {
  const data = localStorage.getItem("admin");
  const admin = data ? JSON.parse(data) : null;
  // console.log(admin); 

  return (
    <BrowserRouter>
      <Routes>

     
        <Route
          path="/"
          element={ <Login />}
        />

 
        <Route
          path="/admin-login"
          element={admin ? <Navigate to="/admin/dashboard" /> : <Adminlogin />}
        />

        <Route
          path="/admin"
          element={admin ? <Sidebar admin={admin} /> : <Navigate to="/" />}
        >
    
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="manage-projects" element={<Manageprojects />} />
          <Route path="project-completion" element={<Projectcompletion admin={admin}/>} />
          <Route path="manage-staff" element={<Managesubpanel />} />
              <Route path="invoice-form" element={<Invoiceform />} />

   

            <Route path="project-alloted" element={<Projectalloted />} />
             <Route path="on-boarding" element={<Clientonboarding />} />

        
        </Route>

      
        <Route path="*" element={<Pnf/>} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
